import type { Route } from './+types/EventsPage'
import { PageShell } from '@/components/layout/PageShell'
import { EventCard } from '@/components/app/EventCard'
import { useUpcomingEvents } from '@/lib/cms/hooks'
import { createContentLoader } from '@/lib/cms/prefetch.server'
import { contentQueries } from '@/lib/cms/queries'
import { useTranslation } from '@/lib/i18n/LocaleContext'
import { messages } from '@/lib/i18n/messages'
import { localeFromParams } from '@/lib/routeLocale'
import { buildMeta, type PageSeo } from '@/lib/seo'

export async function loader({ params }: Route.LoaderArgs) {
  const locale = localeFromParams(params)
  const content = createContentLoader(locale)
  await content.prefetch([contentQueries.upcomingEvents()])
  const seo: PageSeo = { title: messages[locale].app.eventsTitle }
  return { dehydratedState: content.dehydrate(), seo }
}

export const meta: Route.MetaFunction = (args) => buildMeta(args, args.data?.seo)

export default function EventsPage() {
  const { t } = useTranslation()
  const { data, loading, error } = useUpcomingEvents()
  return (
    <PageShell>
      <section className="block-tight">
        <div className="wrap wrap-narrow">
          <h1 className="h1">{t.app.eventsTitle}</h1>
          {loading && <p className="muted">{t.common.loading}</p>}
          {error && <p className="error-text">{t.common.error}</p>}
          {data && data.length === 0 && <p className="muted">{t.app.noEvents}</p>}
          {data && data.length > 0 && (
            <ul className="card-list card-list-single">
              {data.map((e) => <li key={e.id}><EventCard event={e} /></li>)}
            </ul>
          )}
        </div>
      </section>
    </PageShell>
  )
}
